export const roleTypes = [
  { value: 'OWNER', text: 'owner', icon: 'mdi-alert-circle-check-outline' },
  { value: 'CONSIGNER', text: 'consigner', icon: 'mdi-check' },
  { value: 'VISIT', text: 'visit', icon: 'mdi-close' },
  { value: 'REGISTRATION', text: 'registration', icon: 'mdi-close' },
] as const

export type RoleType = typeof roleTypes[number]['value']

const mapRoleTypes : Map<string, string> = new Map()
roleTypes.forEach((e) => {
  mapRoleTypes.set(e.value, e.text)
})

export function getRoleTypeLabel(key: string) : string {
  return key && mapRoleTypes.get(key) || ''
}
